import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function AndroidFingerPrint({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M14.0367 18.3563C14.1526 18.6058 14.0442 18.902 13.7947 19.0179C12.6416 19.5533 11.4992 19.6516 10.5632 19.222C9.61375 18.7861 8.99475 17.862 8.79141 16.6081L9.77479 16.4486C9.93907 17.4617 10.4031 18.0523 10.9788 18.3166C11.5678 18.5869 12.3925 18.5706 13.3752 18.1143C13.6247 17.9984 13.9209 18.1068 14.0367 18.3563Z"
        fill={iconColor}
      />
      <Path
        d="M12.6793 11.3208V13.3585H11.0944V14.2642H13.5849V11.3208H12.6793Z"
        fill={iconColor}
      />
      <Path
        d="M18.3397 9.0566C18.3397 9.55678 17.9342 9.96226 17.434 9.96226C16.9339 9.96226 16.5284 9.55678 16.5284 9.0566C16.5284 8.55642 16.9339 8.15094 17.434 8.15094C17.9342 8.15094 18.3397 8.55642 18.3397 9.0566Z"
        fill={iconColor}
      />
      <Path
        d="M6.566 9.96226C7.06618 9.96226 7.47166 9.55678 7.47166 9.0566C7.47166 8.55642 7.06618 8.15094 6.566 8.15094C6.06582 8.15094 5.66034 8.55642 5.66034 9.0566C5.66034 9.55678 6.06582 9.96226 6.566 9.96226Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 23.0943C18.1272 23.0943 23.0943 18.1272 23.0943 12C23.0943 5.87277 18.1272 0.90566 12 0.90566C5.87277 0.90566 0.90566 5.87277 0.90566 12C0.90566 18.1272 5.87277 23.0943 12 23.0943Z"
        fill={iconColor}
      />
    </Svg>
  );
}
